import { Box, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { FHButton } from '../../../components/base';
import { FORTA_BLUE, FORTA_ERROR, FORTA_GRAY4, FORTA_WHITE } from '../../../utils/colors';
import { SessionNoteSteps } from './constants';
import { validateCheckBoxFields } from './utils';
import ErrorAlertIcon from '../../../components/svgs/ErrorAlertIcon';
import { useValidateDuration } from '../../../hooks/useValidateDuration';

import type { ISessionNotesFooter } from './types';

function SessionNotesFooter({
  values,
  isEditable,
  session,
  currentStep,
  loading,
  handlePrevClick,
  handleNextClick,
}: ISessionNotesFooter) {
  const validateDuration = useValidateDuration({
    startDate: session?.date_start,
    duration: session?.expected_duration,
  });

  return (
    <Box
      sx={{ display: 'flex', mt: 5, mb: 5, justifyContent: 'space-between', alignItems: 'center' }}
    >
      <Typography variant="overline" color={FORTA_BLUE.primary}>
        {currentStep + 1} / 3
      </Typography>
      {!validateCheckBoxFields(values) &&
        currentStep > SessionNoteSteps.SymptomsAndInterventions && (
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: 10 }}>
            <ErrorAlertIcon color={FORTA_ERROR} />
            <Typography textAlign="left" color={FORTA_ERROR} ml={1}>
              Missing information on page 1
            </Typography>
          </Box>
        )}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <FHButton
          data-testid="sessionNotePrevious"
          sx={{
            height: 40,
            fontSize: '1em',
            mr: 3,
            visibility:
              currentStep > SessionNoteSteps.SymptomsAndInterventions ? 'visible' : 'hidden',
            backgroundColor: FORTA_WHITE,
            color: FORTA_GRAY4,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: FORTA_BLUE.light2,
            ':hover': { color: FORTA_GRAY4, backgroundColor: FORTA_WHITE },
            ':disabled': {
              backgroundColor: FORTA_WHITE,
              color: FORTA_GRAY4,
              opacity: 0.7,
            },
          }}
          startIcon={<ChevronLeftIcon />}
          disabled={currentStep === SessionNoteSteps.SymptomsAndInterventions || loading}
          onClick={handlePrevClick}
        >
          Previous
        </FHButton>
        <FHButton
          sx={{
            height: 40,
            minWidth: '110px',
            fontSize: '1em',
          }}
          data-testid={
            currentStep === SessionNoteSteps.SessionNarrative
              ? 'sessionNoteConclude'
              : 'sessionNoteNext'
          }
          endIcon={currentStep !== SessionNoteSteps.SessionNarrative && <ChevronRightIcon />}
          onClick={handleNextClick}
          disabled={
            (currentStep === SessionNoteSteps.SymptomsAndInterventions && !session) ||
            (currentStep === SessionNoteSteps.SessionNarrative && !isEditable) ||
            loading
          }
        >
          {currentStep === SessionNoteSteps.SessionNarrative
            ? validateDuration
              ? 'Conclude'
              : 'End early'
            : 'Next'}
        </FHButton>
      </Box>
    </Box>
  );
}

export default SessionNotesFooter;
